// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__8IwGW","spinner":"Loader_spinner__1tOgn"};